export const formName = 'frm_loan_view'
export const permissionsFormName = 'frm_sec_RL'

export const stopAccrualsModalName = 'stopAccrualsModalName'
export const undoStopAccrualsModalName = 'undoStopAccrualsModalName'

export const stopAccrualsFetcherName = 'stopAccrualsFetcherName'
export const undoStopAccrualsFetcherName = 'undoStopAccrualsFetcherName'
export const addPermissionFetcherName = 'addPermissionFetcherName'

export const loanPermissionsModalName = 'loan-permissions-modal'
export const addLoanPermissionsModalName = 'add-loan-permissions-modal'
export const deleteLoanPermissionModalName = 'delete-loan-permissions-modal'
export const reserveManualModalName = 'reserve-manual-modal'
export const reserveAutoModalName = 'reserve-auto-modal'
export const LOAN_DETAILS_MODAL = 'LOAN_DETAILS_MODAL'

export interface ActiveNotesModalGridFields {
  NT: string
  CDate: string
  LoginFull: string
  Type: string
  Body: string
  GDate: string
}

export interface ActiveNoteContextMenuActions {
  openEditNoteModal: (data) => {}
  openPreviewNoteModal: (data) => {}
  openNoteDelete: (data) => {}
}

export interface ActiveNoteData {
  id: string
  hash: string
  clientid: string
  clienthash: string
  producttype: number
}

export interface DetailModalParams {
  ID?: number
  hash?: string
}
